import React from 'react'
import style from './PrequalBlock.module.scss'

export interface IPrequalBlockProps {
  accept?: boolean
}

const PrequalBlock = React.memo<IPrequalBlockProps>(
  ({ accept }) => (
    <div
      className={`${style.prequal} ${true == accept ? style.accept : false == accept ? style.reject : ''}`}
      data-testid="SW-Question-PQHint"
    >
      ({true == accept ? 'Accept' : false == accept ? 'Reject' : '--------'})
    </div>
  ),
  (prevProps, nextProps) => prevProps.accept === nextProps.accept
)

PrequalBlock.displayName = 'PrequalBlock'

export default PrequalBlock
